/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const SORT_OPTIONS = {
  defaultSortOptions: [
    {
      key: "SN_NO_SORT",
      value: "1",
      translationKey: "CommerceEnvironment.listSettings.relevance",
    },
    {
      key: "SN_SORT_BY_NEW_FIRST",
      value: "5",
      translationKey: "CommerceEnvironment.listSettings.NewHighToLow",
    },
    {
      key: "SN_SORT_BY_NEW_LAST",
      value: "6",
      translationKey: "CommerceEnvironment.listSettings.NewLowToHigh",
    },
    // {
    //   key: "SN_SORT_BY_BRANDS",
    //   value: "1",
    //   translationKey: "CommerceEnvironment.listSettings.brands",
    // },
    // {
    //   key: "SN_SORT_BY_NAME",
    //   value: "2",
    //   translationKey: "CommerceEnvironment.listSettings.name",
    // },
  ],
  priceSortOptions: [
    {
      key: "SN_SORT_LOW_TO_HIGH",
      value: "3",
      translationKey: "CommerceEnvironment.listSettings.priceLowToHigh",
    },
    {
      key: "SN_SORT_HIGH_TO_LOW",
      value: "4",
      translationKey: "CommerceEnvironment.listSettings.priceHighToLow",
    },
  ],
};

export const PAGELIMIT_OPTIONS = {
  defaultPageLimitOptions: [
    {
      key: "SN_2_ITEMS",
      value: "12",
    },
    {
      key: "SN_4_ITEMS",
      value: "24",
    },
    {
      key: "SN_8_ITEMS",
      value: "36",
    },
    {
      key: "SN_16_ITEMS",
      value: "48",
    },
  ]
};

export const ATTR_IDENTIFIER = {
  PickUp: "PickUpInStore",
  RibbonAd: "ribbonad",
};

export const  CDN_IMG_URL = "https://dpjye2wk9gi5z.cloudfront.net/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/default/";
